
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Tabs, Tab, } from '@material-ui/core';
import TabIndicator from '../view/TabIndicator';

class AnchorHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
        };
    }

    _handleChange(val) {
        this.setState({ value: val });
        this.props.onChange && this.props.onChange(this.props.data[val]);
    }

    _onClickLeagueMatch = () => {
        this.props.history.push('matchleague');
    }

    _onClickChoose() {
        this.props.history.push('matchchoose');
    }

    render() {
        const { data } = this.props;
        const { value } = this.state;
        return (
            <Grid container alignItems='center' direction='row' style={{ width: '86vw', flex: 1 }} >
                {
                    data && data.length != 0 && <Tabs
                        value={value}
                        onChange={(e, val) => this._handleChange(val)}
                        TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                    >
                        {
                            data.map((item, i) => (
                                <Tab
                                    key={i} index={i}
                                    label={item.name}
                                    style={{ color: value == i ? '#0D0D0D' : '#878787', fontSize: 14 }}
                                >
                                </Tab>
                            ))
                        }
                    </Tabs>
                }
            </Grid>
        );
    }

}

export default withRouter(withStyles((theme) => ({


}))(AnchorHeader));